module.exports = __webpack_public_path__ + "img/lgl_32-50-m.prt.143dc53c.jpg";